import { render, staticRenderFns } from "./NewPermissionModal.vue?vue&type=template&id=2b868dad&scoped=true"
import script from "./NewPermissionModal.vue?vue&type=script&lang=js"
export * from "./NewPermissionModal.vue?vue&type=script&lang=js"
import style0 from "./NewPermissionModal.vue?vue&type=style&index=0&id=2b868dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b868dad",
  null
  
)

export default component.exports